function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "alert-triangle"
}, /*#__PURE__*/React.createElement("path", {
  id: "Icon",
  d: "M9.99988 8.00019V11.3335M9.99988 14.6669H10.0082M8.84598 3.74329L1.9919 15.5821C1.61173 16.2388 1.42165 16.5671 1.44974 16.8366C1.47425 17.0716 1.59739 17.2852 1.78852 17.4242C2.00765 17.5835 2.38704 17.5835 3.14581 17.5835H16.8539C17.6127 17.5835 17.9921 17.5835 18.2112 17.4242C18.4024 17.2852 18.5255 17.0716 18.55 16.8366C18.5781 16.5671 18.388 16.2388 18.0078 15.5821L11.1538 3.74329C10.775 3.08899 10.5856 2.76184 10.3385 2.65196C10.1229 2.55612 9.87684 2.55612 9.66129 2.65196C9.41419 2.76184 9.22478 3.08899 8.84598 3.74329Z",
  stroke: "#D83338",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

function SvgAlertTriangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.13474193.svg";
export { ForwardRef as ReactComponent };